import React from "react";
import { useHistory } from "react-router-dom";
import { IconShieldLock, IconMapSearch } from "@tabler/icons";
import { Page, Button, EmptyState, Skeleton, Spinner } from "../ui";
import { roleHome } from "./roleHome";
import { roleName, ROLE_NAMES } from "./session";

// Placeholders the shell shows while a page loads, for unknown paths and for
// pages the signed-in role may not open.

export const PageLoading = () => (
  <div className="app-page-loading" role="status" aria-label="Loading page">
    <Skeleton width={220} height={26} />
    <Skeleton width={340} height={14} style={{ marginTop: 10 }} />
    <div className="app-page-loading-cards">
      {[0, 1, 2, 3].map((i) => (
        <Skeleton key={i} height={88} radius={12} />
      ))}
    </div>
    <Skeleton height={320} radius={12} style={{ marginTop: 16 }} />
  </div>
);

// Full-screen loader for pages outside the shell (sign in).
export const ScreenLoading = () => (
  <div className="pa app-screen-loading">
    <Spinner size={28} label="Loading" />
  </div>
);

export function Forbidden({ roles }) {
  const history = useHistory();
  const who = (roles || []).map((r) => ROLE_NAMES[r]).filter(Boolean);
  const unique = who.filter((name, i) => who.indexOf(name) === i);
  return (
    <Page>
      <EmptyState
        icon={<IconShieldLock size={26} stroke={1.6} />}
        title="You don't have access to this page"
        action={
          <Button variant="primary" onClick={() => history.push(roleHome())}>
            Go to your dashboard
          </Button>
        }
      >
        {unique.length ? `This page is for the ${unique.join(" / ")} role. ` : ""}
        You are signed in as {roleName()}.
      </EmptyState>
    </Page>
  );
}

export function NotFound() {
  const history = useHistory();
  return (
    <Page>
      <EmptyState
        icon={<IconMapSearch size={26} stroke={1.6} />}
        title="Page not found"
        action={
          <Button variant="primary" onClick={() => history.push(roleHome())}>
            Go to your dashboard
          </Button>
        }
      >
        The link may be old, or the page has moved. Use the menu to find what you need.
      </EmptyState>
    </Page>
  );
}
